module.exports = __webpack_public_path__ + "static/Rapidops-ServicePage-bb0a5273aca437b02aeb69c80c02e97d.mp4";